module.exports = __webpack_public_path__ + "img/icon47.03a57da7.png";